import Layout from "@/layout";

export default {
  path: "/document",
  component: Layout,
  redirect: "/document/index",
  children: [
    {
      path: "index",
      name: "document",
      component: () => import(/* webpackChunkName: "document" */ "@/views/document-v2/components"),
      meta: { title: "Documents", icon: "document-v2", keepName: 'Documents', keepAlive: true }
    }
  ]
}